import { FormCategory } from './form-category';
import { SearchType } from '../search/search.type';

// /api/formtemplate/

export enum FormTemplateType {
  Pdf = 1,
  Fillable = 2,
  PersonalizedPlan = 3,
}

export class FormTemplate {
  public id?: number;
  public name?: string;
  public parent?: number;
  public attachment?: string;
  public completed_at?: string;
  public category?: any;
  public form_type?: [number, string];
  public is_deleted?: boolean;
  public is_stock?: [boolean, string] | any;
  public is_pne: boolean;
  public main_text?: string;
  public signees?: [];
  public status?: number;
  public template?: string;
  public validity_period?: any;
  public files: FormTemplateFile[];
  public type?: any;
  public media?: any; // used in user_file migration
  public clinic?: number | any;
  public metadata?: any;

  public url_original?: any;
  public url_built?: any;

  // Comments weak reference
  public comments?: any; // {  }

  public _selected = false;

  public order?: number;

  public updated_at?: Date;

  public position_after?: number;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.name = data.name || void 0;
    this.category = data.category || void 0;
    this.is_deleted = data.is_deleted || false;
    this.is_stock = data.is_stock || void 0;
    this.attachment = data.attachment || void 0;
    this.main_text = data.main_text || void 0;
    this.completed_at = data.completed_at || void 0;
    this.status = data.status || void 0;
    this.template = data.template || void 0;
    this.validity_period = data.validity_period || void 0;
    this.files = data.files || void 0;
    this.order = data.order >= 0 ? data.order : void 0;
    this.updated_at = data.updated_at ? data.updated_at : void 0;
    this.type = data.type ? data.type : 2; // Always Editable if not set
    this.position_after = data.position_after ? data.position_after : void 0;
    this.clinic = data.clinic ? data.clinic : void 0;
    this.media = data.media ? data.media : [];
    this.signees = data.signees ? data.signees : [];
    this.metadata = data.metadata ? data.metadata : void 0;
    this.is_pne = data.is_pne ?? false;
  }

  // TODO: Promote to model
  public getTypeText?() {
    switch (this.type) {
      case FormTemplateType.Pdf: {
        return 'PDF Form';
      }
      case FormTemplateType.Fillable: {
        return 'Fillable Form';
      }
      case FormTemplateType.PersonalizedPlan: {
        return 'Personalized Plan';
      }
    }
    return '-';
  }

  public ofType = (type: SearchType) => {
    const stock = this.is_stock[0] === true;
    const deleted = this.is_deleted === true;

    switch (type) {
      case SearchType.GlobalLibrary:
        return stock === true && this.category && !deleted;
      case SearchType.GlobalLibraryUploaded:
        return stock === true && !deleted && this.type === 1;
      case SearchType.GlobalLibraryArchive:
        return stock && deleted === true;
      case SearchType.AccountLibrary:
        return stock === false && !deleted && this.category > 0;
      case SearchType.AccountLibraryArchive:
        return this.category > 0 && stock === false && deleted === true;
      case SearchType.AccountLibraryUploaded:
        return this.type === 1 && !this.category && !deleted;
      case SearchType.AccountLibraryUploadedArchived:
        return this.type === 1 && !this.category && deleted === true;
      case SearchType.PracticeLibraryPublished:
        return !this.category && this.status === 4 && !deleted && this.clinic > 0;
      case SearchType.PracticeLibraryPending:
        return !this.category && this.status !== 4 && !deleted && this.clinic > 0;
      case SearchType.PracticeLibraryPublishedArchived:
        return !this.category && this.status === 4 && deleted === true && this.clinic > 0;
      case SearchType.PracticeLibraryPendingArchived:
        return !this.category && this.status !== 4 && deleted === true && this.clinic > 0;
      default:
        return false;
    }
  };
}

export class FormTemplateFile {
  public id: number;
  public content: string;
  public type: FormTemplateFileTypes;
}

export enum FormTemplateFileTypes {
  ORIGINAL = 0,
  BUILT = 1,
}
